import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useManageProjectPlansPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		...useQuery(() => new q.ManageProjectPlansPageQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value))
	}
	return {
		...result,
		runManageProjectPlansPageQueryV1: result.run,
		modelManageProjectPlansPageQueryV1: result.model,
	}
}

export function useProjectCapexQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, denomination?: any | null | Ref<any | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const _denomination = isRef<any | null>(denomination) ? denomination : ref<any | null>(denomination)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		denomination: _denomination,
		...useQuery(() => new q.ProjectCapexQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value, _denomination.value))
	}
	return {
		...result,
		runProjectCapexQueryV1: result.run,
		modelProjectCapexQueryV1: result.model,
	}
}

export function useProjectExpenseAllocationsQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, granularity?: any | null | Ref<any | null>, denomination?: any | null | Ref<any | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>(granularity)
	const _denomination = isRef<any | null>(denomination) ? denomination : ref<any | null>(denomination)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		granularity: _granularity,
		denomination: _denomination,
		...useQuery(() => new q.ProjectExpenseAllocationsQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value, _granularity.value, _denomination.value))
	}
	return {
		...result,
		runProjectExpenseAllocationsQueryV1: result.run,
		modelProjectExpenseAllocationsQueryV1: result.model,
	}
}

export function useProjectExpenseSavingsQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, granularity?: any | null | Ref<any | null>, denomination?: any | null | Ref<any | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>(granularity)
	const _denomination = isRef<any | null>(denomination) ? denomination : ref<any | null>(denomination)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		granularity: _granularity,
		denomination: _denomination,
		...useQuery(() => new q.ProjectExpenseSavingsQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value, _granularity.value, _denomination.value))
	}
	return {
		...result,
		runProjectExpenseSavingsQueryV1: result.run,
		modelProjectExpenseSavingsQueryV1: result.model,
	}
}

export function useProjectMarginsQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, granularity?: any | null | Ref<any | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>(granularity)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		granularity: _granularity,
		...useQuery(() => new q.ProjectMarginsQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value, _granularity.value))
	}
	return {
		...result,
		runProjectMarginsQueryV1: result.run,
		modelProjectMarginsQueryV1: result.model,
	}
}

export function useProjectPhasesQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		...useQuery(() => new q.ProjectPhasesQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value))
	}
	return {
		...result,
		runProjectPhasesQueryV1: result.run,
		modelProjectPhasesQueryV1: result.model,
	}
}

export function useProjectPlanListQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		...useQuery(() => new q.ProjectPlanListQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value))
	}
	return {
		...result,
		runProjectPlanListQueryV1: result.run,
		modelProjectPlanListQueryV1: result.model,
	}
}

export function useProjectPlanPnlQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, pnlId?: string | null | Ref<string | null>, applyBenefitsConfidenceFactor?: boolean | Ref<boolean>, denomination?: any | null | Ref<any | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const _pnlId = isRef<string | null>(pnlId) ? pnlId : ref<string | null>(pnlId)
	const _applyBenefitsConfidenceFactor = isRef<boolean>(applyBenefitsConfidenceFactor) ? applyBenefitsConfidenceFactor : ref<boolean>(applyBenefitsConfidenceFactor)
	const _denomination = isRef<any | null>(denomination) ? denomination : ref<any | null>(denomination)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		pnlId: _pnlId,
		applyBenefitsConfidenceFactor: _applyBenefitsConfidenceFactor,
		denomination: _denomination,
		...useQuery(() => new q.ProjectPlanPnlQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value, _pnlId.value, _applyBenefitsConfidenceFactor.value, _denomination.value))
	}
	return {
		...result,
		runProjectPlanPnlQueryV1: result.run,
		modelProjectPlanPnlQueryV1: result.model,
	}
}

export function useProjectPlanSettingsPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		...useQuery(() => new q.ProjectPlanSettingsPageQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value))
	}
	return {
		...result,
		runProjectPlanSettingsPageQueryV1: result.run,
		modelProjectPlanSettingsPageQueryV1: result.model,
	}
}

export function useProjectPlanSummaryPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, granularity?: any | null | Ref<any | null>, denomination?: any | null | Ref<any | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>(granularity)
	const _denomination = isRef<any | null>(denomination) ? denomination : ref<any | null>(denomination)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		granularity: _granularity,
		denomination: _denomination,
		...useQuery(() => new q.ProjectPlanSummaryPageQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value, _granularity.value, _denomination.value))
	}
	return {
		...result,
		runProjectPlanSummaryPageQueryV1: result.run,
		modelProjectPlanSummaryPageQueryV1: result.model,
	}
}

export function useProjectResourceAllocationsQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, granularity?: any | null | Ref<any | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>(granularity)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		granularity: _granularity,
		...useQuery(() => new q.ProjectResourceAllocationsQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value, _granularity.value))
	}
	return {
		...result,
		runProjectResourceAllocationsQueryV1: result.run,
		modelProjectResourceAllocationsQueryV1: result.model,
	}
}

export function useProjectResourceSavingsQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, granularity?: any | null | Ref<any | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>(granularity)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		granularity: _granularity,
		...useQuery(() => new q.ProjectResourceSavingsQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value, _granularity.value))
	}
	return {
		...result,
		runProjectResourceSavingsQueryV1: result.run,
		modelProjectResourceSavingsQueryV1: result.model,
	}
}

export function useProjectResourceUnitCostsQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		...useQuery(() => new q.ProjectResourceUnitCostsQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value))
	}
	return {
		...result,
		runProjectResourceUnitCostsQueryV1: result.run,
		modelProjectResourceUnitCostsQueryV1: result.model,
	}
}

export function useProjectRevenuesQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, projectId?: string | Ref<string>, projectPlanId?: string | null | Ref<string | null>, granularity?: any | null | Ref<any | null>, denomination?: any | null | Ref<any | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const _projectPlanId = isRef<string | null>(projectPlanId) ? projectPlanId : ref<string | null>(projectPlanId)
	const _granularity = isRef<any | null>(granularity) ? granularity : ref<any | null>(granularity)
	const _denomination = isRef<any | null>(denomination) ? denomination : ref<any | null>(denomination)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		projectId: _projectId,
		projectPlanId: _projectPlanId,
		granularity: _granularity,
		denomination: _denomination,
		...useQuery(() => new q.ProjectRevenuesQueryV1(_workspaceId.value, _tchProjectId.value, _projectId.value, _projectPlanId.value, _granularity.value, _denomination.value))
	}
	return {
		...result,
		runProjectRevenuesQueryV1: result.run,
		modelProjectRevenuesQueryV1: result.model,
	}
}

